import { render, staticRenderFns } from "./flight-pad-details-bags.vue?vue&type=template&id=56b4ed9d&scoped=true"
import script from "./flight-pad-details-bags.vue?vue&type=script&lang=js"
export * from "./flight-pad-details-bags.vue?vue&type=script&lang=js"
import style0 from "./flight-pad-details-bags.vue?vue&type=style&index=0&id=56b4ed9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b4ed9d",
  null
  
)

export default component.exports